import { RouteConfig } from 'vue-router'


const builder: Array<RouteConfig> = [
  {
    path: '/',
    name: 'builder',
  },
  {
    path: '/gpt/step/1',
    name: 'step1',
    component: () => import('@/views/buildergpt/Step1.vue'),
   
  },
  {
    path: '/gpt/step/2',
    name: 'step2',
    component: () => import('@/views/buildergpt/Step2.vue'),
   
  },
  {
    path: '/gpt/step/3',
    name: 'step3',
    component: () => import('@/views/buildergpt/Step3.vue'),
   
  },
  {
    path: '/gpt/step/4',
    name: 'step4',
    component: () => import('@/views/buildergpt/Step4.vue'),
   
  },
  {
    path: '/gpt/step/5',
    name: 'step5',
    component: () => import('@/views/buildergpt/Step5.vue'),
   
  },
  {
    path: '/gpt/step/6',
    name: 'step6',
    component: () => import('@/views/buildergpt/Step6.vue'),
   
  },
  
]

export default builder
